export function buildProspectorPageURL() {
  return '/prospector'
}
